import React, { useEffect, useState } from 'react';
import './CompensationLeaveTable.css';
import CustomModal from '../../../../Components/custom_components/CustomModal/CustomModal';
import Loader from '../../../../Components/Loader/Loader';
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination';
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable';
import { useSelector } from 'react-redux';
import { get_compensationLeave_with_pagination } from '../../../../config/ManagementApis/LeaveRequestApis';
import CompensationLeaveFilter from '../CompensationLeaveSearchFilter/CompensationLeaveFilter';
import { Icons } from '../../../../utils/GlobalIcons';
import CompensationLeaveDetailsView from '../CompensationLeaveComponents/CompensationLeaveDetailsView';
import AvailedLeaveDetailsView from '../CompensationLeaveComponents/AvailedLeaveDetailsView';
import { handlePaginationEntries } from '../../../../utils/pagination';
import { hasPrivilege } from '../../../../utils/privileges';

function CompensationLeaveTable() {

    const privileges = useSelector((state) => state.privileges.privileges);

    const [Listing, SetListing] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });
    const [filterValues, setFilterValues] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState(

        { totaldays: 0, leavesBalance: 0, leaveTaken: 0, dates: [], isOpen: false }
    );
    const [selectedLeaves, setSelectedLeaves] = useState(null);

    const fetchCompensationLeave = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);
        Object.keys(filterValues)?.forEach(key => {
            formData.append(key, filterValues[key]);
        });

        try {
            setIsLoading(true);
            const response = await get_compensationLeave_with_pagination(formData);

            if (response?.status === "success") {
                const data = response.data;
                SetListing(data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                SetListing([]);
            }
        } catch (error) {
            console.error("Fetch error", error);
            SetListing([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCompensationLeave();
    }, [pageNumber, totalItemPerPage, filterValues]);


    //------------New code after privielegae uing id
    // Define the required permission actions
    const PERMISSION_ACTIONS = {
        view: 4,
        list: 2,

    };

    // Map permissions to boolean values based on privileges
    const userPermissions = {
        view: hasPrivilege(privileges, "Leave", 33, PERMISSION_ACTIONS.view),
    };
    const hasActionPermissions = userPermissions.view;  // At least one action permission is required
    //-------------------END


    const columns = [
        { title: "#", key: "key" },
        { title: "Employee Name", key: "employeeName" },
        { title: "Total Days", key: "totaldays" },
        { title: "Leave Taken", key: "leaveTaken" },
        { title: "Leave Balance", key: "leavesBalance" },
        { title: "Actions", key: "actions", render: (text, row) => renderActions(row) },
    ].filter(column => column.key !== "actions" || hasActionPermissions); //removes the "Actions" column when hasActionPermissions is false

    // Render action icons for each project item
    const renderActions = (row) => (
        <div className="action-container">
            {userPermissions.view && <Icons.View className="view-action-icon" onClick={() => setSelectedDetails({
                totaldays: row?.totaldays ?? 0,
                leavesBalance: row?.leavesBalance ?? 0,
                leaveTaken: row?.leaveTaken ?? 0,
                dates: row?.date ?? [],
                isOpen: true
            })} />}
        </div>
    );

    const rows = () => Listing?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        employeeName: item?.employeeName ?? "N/A",
        totaldays: item?.totaldays ?? 0,
        leaveTaken: item?.leaveTaken ?? 0,
        leavesBalance: item?.leavesBalance ?? 0,
        details: item?.details ?? [],
        leaves: item?.leaves ?? [],
        date: item?.date ?? [],

    }));

    const handleSearchFilter = (filters) => setFilterValues(filters);
    const handlePageChange = (page) => setPageNumber(page);
    const handleItemPageCountChange = (count) => setTotalItemPerPage(count);
    return (
        <div className='project-management-table-container'>
            <CompensationLeaveFilter
                tableTitle="Compensation Leaves"
                searchFilter={handleSearchFilter}
                refresh={false}
                on_change_value={handlePageChange}
                on_page_count_update={handleItemPageCountChange}
            />

            <div>
                <CustomTable columns={columns} rows={isLoading ? [] : rows()} isLoading={isLoading} />
            </div>

            <div className='bottom-container'>
                {isLoading ? (
                    <Loader />
                ) : (
                    <CustomBottomPagination
                        items_per_page={totalItemPerPage}
                        current_page={pageNumber}
                        total_page_count={totalPages}
                        on_change_value={handlePageChange}
                        on_page_count_update={handleItemPageCountChange}
                        pagination={pagination}
                    />
                )}
            </div>

            {/* Compensation Leave Details Modal */}
            {selectedDetails.isOpen &&
                <CustomModal
                    open={selectedDetails.isOpen}
                    handleClose={() => setSelectedDetails({ totaldays: 0, leavesBalance: 0, leaveTaken: 0, dates: [], isOpen: false })}
                    title="Compensation Leave Details"
                    maxWidth="1000px"
                    body={
                        <CompensationLeaveDetailsView dates={selectedDetails?.dates}
                            leaveInfo={selectedDetails}
                        />

                    }
                />
            }


            {/* Availed Leave Details Modal */}
            {/* {Boolean(selectedLeaves) && <CustomModal
                open={Boolean(selectedLeaves)}
                handleClose={() => setSelectedLeaves(null)}
                title="Available Leave Details"
                maxWidth="600px"
                body={<AvailedLeaveDetailsView leaves={selectedLeaves} />}
            />} */}


        </div>
    );
}

export default CompensationLeaveTable;
